/**
 * ScenariosTabs — shared tab bar for the merged scenario-planning surfaces:
 * Monte Carlo (single-strategy) / MC × Jurisdictions / What-If / Stacker /
 * Drawdown. The sidebar surfaces only 'Scenarios' now; this bar lets users
 * move between the sub-tools.
 */
import { useLocation } from 'react-router-dom'

const TABS: Array<{ href: string; label: string }> = [
  { href: '/app/monte-carlo', label: 'Monte Carlo' },
  { href: '/app/mc-jurisdictions', label: 'Jurisdictions' },
  { href: '/app/scenarios', label: 'What-If' },
  { href: '/app/stacker', label: 'Stacker' },
  { href: '/app/drawdown', label: 'Drawdown Order' },
]

export default function ScenariosTabs() {
  const location = useLocation()
  const current = location.pathname

  return (
    <div className="flex items-center gap-1 border-b border-border flex-wrap">
      {TABS.map(t => {
        const active = current === t.href
        return (
          <a
            key={t.href}
            href={t.href}
            className={
              active
                ? 'px-4 py-2.5 text-sm font-medium border-b-2 border-amber-400 text-amber-400 -mb-px'
                : 'px-4 py-2.5 text-sm font-medium text-text-muted hover:text-text-secondary border-b-2 border-transparent -mb-px'
            }
          >
            {t.label}
          </a>
        )
      })}
    </div>
  )
}
